import React, {Fragment} from "react";
import {useLocation} from "react-router-dom";
import CommonHeader from "../../components/Headers/CommonHeader";
import ProtectedContent from "../../components/protectedContent";
import SafeView from "../../components/safeView/SafeView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import AddCustomer from "./addCustomer";
import CustomersTable from "./customersTable";
import "../commonView.scss";

const CustomersComponent = () => {
  const {state} = useLocation();
  const {
    isOpen: isAddCustomerOpen,
    onOpen: openAddCustomer,
    onClose: closeAddCustomer,
  } = useDisclosure();

  let isDefaultRoute = false;
  if (state?.isFromDefaultRoute) {
    isDefaultRoute = state.isFromDefaultRoute;
  }

  return (
    <SafeView>
      <ProtectedContent perms={["view_customer"]} showFallback>
        <Fragment>
          {isAddCustomerOpen && (
            <AddCustomer
              open={isAddCustomerOpen}
              defaultRoute={isDefaultRoute}
              onCancel={closeAddCustomer}
            />
          )}
          <ProtectedContent perms={["add_customer"]}>
            <CommonHeader
              content={"Add Customer "}
              handleAddClick={openAddCustomer}
              testID={"add_customer"}
            />
          </ProtectedContent>
          <CustomersTable
            defaultRoute={isDefaultRoute}
            openAddCustomer={openAddCustomer}
          />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const CustomersPage = () => {
  return (
    <PageURLContextProvider>
      <CustomersComponent />
    </PageURLContextProvider>
  );
};

export default CustomersPage;
